
import actions from '@/shared/actions';
import store  from '@/store';
import microAppManager from '@/utils/microAppManager';
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

type MenuItem = {
  key: string;
  title: string;
  icon?: string;
  path: string;
  id:string;
  children?: MenuItem[];
};

@Component
export default class Menu extends Vue {
  @Prop({ type: Array, default: [] })
  menus!: MenuItem[];

  @Watch("$route.path")
  onPathChange() {
    this._initMenus();
  }

  defaultMenus:object = {
    title: "首页",
    path: "/home",
    key:"Home"
  };
  selectKey: string = "";
  loadingApps: Set<string> = new Set(); // 跟踪正在加载的应用（防重复点击）
  // path: object = {};
  created() {
    this._initMenus();
  /*  window.addEventListener('load',()=>{
      console.log('load')
      console.log('刷新完成')
      // 将selectKey存入
      sessionStorage.setItem('selectKey',this.$store.state.home.currentMenus)
      let microApps:any = sessionStorage.getItem("microApps")
      let selectKey:any = sessionStorage.getItem('selectKey')
      const microApp = JSON.parse(microApps).find((i: any) => selectKey===i.name);
      if(microApp){
          if(this.currentMicroApp){
              // 卸载子应用
              console.log('卸载子应用')
              console.log(this.currentMicroApp)
              this.currentMicroApp.unmount();
          }
          this.currentMicroApp = loadMicroApp(microApp,{ singular:false })
      }
    })*/
  }
  async mounted(){
    if(typeof sessionStorage.getItem("selectKey") == 'string'){
      this.selectKey = sessionStorage.getItem("selectKey") as string
    }
    //  如果本地有菜单数据的值，直接取本地值给vuex中
    if(typeof sessionStorage.getItem("menus") == 'string'){
        var menuSession = sessionStorage.getItem("menus")
        this.$store.commit('getMenus',eval(menuSession as string) )
    }

    // 修复刷新加载问题
    if(typeof sessionStorage.getItem("selectKey") == 'string'){
      var current = sessionStorage.getItem("selectKey")
      console.log(current,'current');
      this.$store.commit('updataCurrentMenus', current)

      const microAppsStr = sessionStorage.getItem("microApps")
      const selectKey = sessionStorage.getItem('selectKey')

      // 添加配置验证
      if (!microAppsStr || !selectKey) {
        console.log('刷新加载: 配置不存在，跳过微应用加载');
        return;
      }

      try {
        const microApps = JSON.parse(microAppsStr);
        const microApp = microApps.find((i: any) => selectKey === i.name);

        if (!microApp) {
          console.log('刷新加载: 未找到匹配的微应用配置');
          return;
        }

        // 等待 Vue 渲染完成
        await this.$nextTick();

        // 使用微应用管理器加载
        console.log('刷新加载: 开始加载微应用', microApp.name);
        await microAppManager.loadMicroApp(microApp, { singular: false });
        console.log('刷新加载: 微应用加载成功');

      } catch (error) {
        console.error('刷新加载: 微应用加载失败', error);
      }
    }
  }
  private _initMenus() {
    console.log('this.$store.state.home.sideMenus',this.$store.state.home.sideMenus);
    const currentMenu = this._findCurrentMenu(
      this.$store.state.home.sideMenus, //传入的参数为完整的菜单栏
      this.$route.path
    ) as MenuItem;
    if (!currentMenu) return;
    const {key} = currentMenu
    this.selectKey = key;
    console.log('this.selectKey',this.selectKey);
  }

  private _findCurrentMenu(
    menus: MenuItem[],
    currentPath: string
  ): MenuItem | null {
    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];
      const { path } = menu;
      if (path === currentPath) return menu;
      const currentMenu = this._findCurrentMenu(
        menu.children || [],
        currentPath
      );
      if (currentMenu) return currentMenu;
    }
    return null;
  }

  /**
   * 切换菜单
   */
  private async changeMenu(item: MenuItem) {
    // 防重复点击
    if (this.loadingApps.has(item.key)) {
      console.log('顶部菜单: 应用正在加载中，请稍候');
      return;
    }

    try {
      store.commit('showLoading');
      this.loadingApps.add(item.key);

      const microAppsStr = sessionStorage.getItem("microApps");
      if (!microAppsStr) {
        throw new Error('微应用配置不存在');
      }

      let microApps;
      try {
        microApps = JSON.parse(microAppsStr);
      } catch (e) {
        throw new Error('微应用配置解析失败');
      }

      const microApp = microApps.find((i: any) => item.key === i.name);
      if(!microApp){
        throw new Error(`未找到应用 ${item.key} 的配置`);
      }

      // 使用统一管理器加载
      console.log('顶部菜单: 开始加载微应用', microApp.name);
      await microAppManager.loadMicroApp(microApp, { singular: false });
      console.log('顶部菜单: 微应用加载成功', microApp.name);

      // 更新状态
      this.$store.commit('updataCurrentMenus', item.key);
      const { key, id } = item;
      actions.setGlobalState({ id });
      sessionStorage.setItem('menusId', item.id);
      sessionStorage.setItem('selectKey', item.key);

    } catch (error) {
      console.error('顶部菜单: 微应用加载失败', error);
      // 可以选择显示错误提示
      // this.$message.error(`应用加载失败: ${error.message}`);
    } finally {
      this.loadingApps.delete(item.key);
      store.commit('hideLoading');
    }
  }

  // 删除菜单
  private async deleteMenuItem(item: MenuItem){
    let microAppsStr = sessionStorage.getItem("microApps")
    // 删除列表对应项
    var i = this.$store.state.home.menus.indexOf(item)
    let selectKey = sessionStorage.getItem('selectKey')

    // 判断当前删除的item 是否就是点击的target
    if(item.key == selectKey){
      if(i == 0){
        // 跳到首页，先卸载所有微应用
        microAppManager.unloadAllMicroApps().catch(error => {
          console.error('卸载微应用失败:', error);
        });
        this.$store.commit('updataCurrentMenus','Home')
        sessionStorage.setItem('selectKey','Home')
        this.$router.push('/home')
      }else if (i > 0){
        this.$store.commit('updataCurrentMenus',this.$store.state.home.menus[i-1].key)
        sessionStorage.setItem('selectKey',this.$store.state.home.menus[i-1].key)
        this.$router.push(this.$store.state.home.menus[i-1].path)
        sessionStorage.setItem('menusId',this.$store.state.home.menus[i-1].id)

        // 加载前一个应用
        if (microAppsStr) {
          try {
            const microApps = JSON.parse(microAppsStr);
            const newSelectKey = this.$store.state.home.menus[i-1].key;
            const microApp = microApps.find((m: any) => newSelectKey === m.name);

            if(microApp){
              console.log('删除菜单: 加载前一个应用', microApp.name);
              await microAppManager.loadMicroApp(microApp, { singular: false });
              console.log('删除菜单: 应用加载成功');
            }
          } catch (error) {
            console.error('删除菜单: 应用加载失败', error);
          }
        }
      }
    }
    this.$store.commit('deleteMenus',i)
  }

  /**
   * 处理 Home 点击事件
   * 在跳转到 Home 前卸载所有微应用
   */
  private async handleHomeClick() {
    try {
      console.log('切换到 Home，卸载所有微应用');
      await microAppManager.unloadAllMicroApps();

      // 更新当前菜单状态
      this.$store.commit('updataCurrentMenus', 'Home');
      sessionStorage.setItem('selectKey', 'Home');

      console.log('所有微应用已卸载，准备跳转到 Home');
    } catch (error) {
      console.error('卸载微应用失败:', error);
    }
  }
}
